<template>
  <div class="formPosition" v-role="'ped'">
    <loading v-if="isLoading" />
    <template>
      <v-container class="grey lighten-5">
        <!--============= CARD SUPERIOR DA TELA =======================-->
        <v-row no-gutters>
          <v-col>
            <h4 style="text-align: center"> <span> Histórico Académico do Estudante</span></h4>
            <div class="text-center">
                <!--===== EXIBINDO A FOTO DO ESTUDANTE ================-->
                  <div md="12">
                    <input style="display: none" ref="input" type="file" name="image" accept="image/*" @change="setImage"/>
                    <img :src="foto" style="width: 140px; height: 140px; border-radius: 10px" @load="progresso2"/>
                    <v-btn @click="showFileChooser()" style="margin-left: 10px; margin-top: -50px" small fab dark color="primary">
                      <v-icon dark small>add_a_photo</v-icon>
                    </v-btn>
                  </div>
                <!--===== FIM EXIBINDO A FOTO DO ESTUDANTE ================-->
                <!--========== INPUT DE PESQUISA NOME DO ESTUDANTE ===========-->
                <div style="width: 35%; text-align: center; margin: 10px auto;">
                  <v-autocomplete
                    style="border-radius: 25px"
                    :loading="isLoading_"
                    placeholder="Pesquisar aluno"
                    outlined
                    v-model="editedItem"
                    :items="alunos"
                    :search-input.sync="search"
                    color="primary"
                    item-text="nome"
                    prepend-icon="mdi-database-search"
                    auto-select-first
                    clearable
                    return-object
                    @change="getHistoricoAluno()"
                    @click="loadStudents()"
                  ></v-autocomplete>
                </div>
                <!--========== FIM INPUT DE PESQUISA NOME DO ESTUDANTE ===========-->
            </div>
          </v-col>
        </v-row>
        <!--============= FIM CARD SUPERIOR DA TELA =======================-->

        <!--============= CARD INFERIOR DA TELA ===========================-->
        <v-card class="mx-auto">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
              <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
            </v-list-item-content>
            <!--===== CONTAINER Impressões / Ações ===============-->
            <v-row>
                  <v-col md="12">
                    <v-menu bottom transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <v-btn dark color="teal" style="color: white; float: right" v-on="on" small> Impressões / Ações </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="carregarBoletim()"><span>Boletim</span></v-list-item>
                        <v-list-item @click="carregarcartaoestudante()"><span>Cartão escolar</span></v-list-item>
                        <v-list-item v-if="isFinalista" @click="carregarCartaRecomendacao()"><span>Carta de Recomendação</span></v-list-item>
                        <v-list-item v-if="isFinalista" @click="carregarCertificado()"><span>Certificado</span></v-list-item>
                        <v-list-item @click="declaracao()"><span>Declaração sem notas</span></v-list-item>
                        <v-list-item @click="declaracao_notas()"><span>Declaração com notas</span></v-list-item>
                        <v-list-item @click="carregarFichaDadosBiograficoAcademico()"><span>Ficha de Dados Biográfico Académico</span></v-list-item>
                        <v-list-item @click="carregarGuiaTransferencia()"><span>Guia de Tranferência</span></v-list-item>
                        <v-list-item @click="carregarHistoricoAcademico()"><span>Histórico Académico</span></v-list-item>
                        <v-list-item @click="showTrancarMatricula()"><span><v-icon>remove_done</v-icon>Trancar Matrícula</span></v-list-item>
                        <v-list-item v-if=" role === 'ROLE_ADM' && editedItem.certificadoImpresso === '1'"  @click="showHabilitarCertificado()"><span>Habilitar Preparação Certificado</span></v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
                <!--===== CONTAINER Impressões / Ações ===============-->
          </v-list-item>
          <v-row>
            <!--======== DADOS PESSOAIS =================-->
            <v-col md="4">
              <v-card-text>
                <strong> Dados Pessoais</strong>
              </v-card-text>
              <hr />
              <ul class="text-gray700 list_container_ul">
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Nome:</span>
                    <span class="text-gray700">{{  this.estudante_dados.length ? this.estudante_dados[0].nome : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Gênero:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].sexo : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Data de nescimento:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].datanascimento : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Natural de:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].provincia : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">B.I:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].bi : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Filho de:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].nomedopai : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">E de:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].nomedamae : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Contato:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].telefone : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Matrícula:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].idMatricula : "" }}</span>
                </li> 
                
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Instituição:</span>
                    <span class="text-gray700">{{ this.estudante_dados.length ? this.estudante_dados[0].instituicao : "" }}</span>
                </li> 
                <li class="flex list_items_ul">
                    <span class="font-bold span_type">Preparação Certificado:</span>
                    <span :style="(this.editedItem.certificadoImpresso === '1')?'color:red;':'color:green;'" class="text-gray700">{{ (this.editedItem.certificadoImpresso === '1')?'Não Indisponível':'Disponível' }}</span>
                </li> 
              </ul>
              <v-list>
                <v-list-item @click="editarEstudante()" v-if="editedItem.certificadoImpresso !== '1'"> <v-icon color="blue">edit</v-icon> Editar Dados</v-list-item>
              </v-list>
            </v-col>
            <!--======== FIM DADOS PESSOAIS =================-->

            <!-- ======== CONTAINER DIREITO DA TELA ============-->
            <v-col md="8">

              <!--======= FORMULÁRIO EDITAR DADOS PESSOAIS ===============-->
              <v-card v-if="formEditarDados" style="padding: 10px;">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="estudanteSelected.nomeDoEstudante" label="*Nome"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="estudanteSelected.bilheteDoEstudante" label="*Nº do B.I"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <template>
                      <v-menu ref="menubi" v-model="menubi" :close-on-content-click="false"
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                        <v-text-field v-model="estudanteSelected.dataBiEstudante"
                          :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI"
                          prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" max="2025-12-31" min="1950-01-01" 
                        v-model="datebi" @change="saveDatebi"></v-date-picker>
                      </v-menu>
                    </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <template>
                      <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="estudanteSelected.dataNascEstudante"
                            :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento"
                            prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" v-model="date" max="2006-12-31" min="1950-01-01"
                          @change="saveDate"></v-date-picker>
                      </v-menu>
                      </template>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="estudanteSelected.nomeDoPai" label="*Filho de"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="estudanteSelected.nomeDaMae" label="*e de"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-combobox :rules="ruleRequired" v-model="provinciaSelected" :items="provinciasAll"
                      item-value="idProvicia" item-text="descricao"  @change="loadMunicipioComb"
                    return-object label="Natural de:"></v-combobox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-combobox :rules="ruleRequired" v-model="municipioSelected"
                      :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao"
                      return-object label="Município"></v-combobox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-combobox v-model="sexoSelected" :rules="ruleRequired" item-value="idSexo"
                    item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="estudanteSelected.telefoneEstudante" label="*Telefone"></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="4">
                    <v-combobox v-model="periodoSelected" :rules="ruleRequired" item-value="id"
                    item-text="descricao" :items="periodos" chips label="Período "></v-combobox>
                  </v-col> -->
                </v-row>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="fecharCardEditar()"> Cancelar </v-btn>
                  <v-btn color="blue darken-1" text @click="salvarDadosEstudante()" >Salvar</v-btn
                  >
                </v-card-actions>
              </v-card>
              <!--======= FIM FORMULÁRIO EDITAR DADOS PESSOAIS ===============-->

              <!--============ CARD DE EXIBIÇÃO DOS DADOS ACADÉMICOS ===========-->
              <v-card v-if="!formEditarDados">
                <v-card-text>
                  <v-tabs v-model="tab" background-color="#006699" center-active dark>
                    <v-tab v-for="item in items" :key="item"> {{ item }}</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <v-card-text>
                        <v-row>
                          <v-col md="12" ><strong> {{ titulo }}</strong></v-col>
                          <v-col md="12">
                            <v-card>
                              <v-card-text>
                                <v-data-table :headers="headers" :items="this.estudante_dados">
                                  <template v-slot:item.estado="{ item }">
                                    <span v-if="item.status_2 == 2" style="color: #a39127" >Matrícula Trancada</span>
                                    <span v-else style="color: green">Activo(a)</span>
                                  </template>
                                  <template v-slot:item.anoLectivo="{ item }">
                                    <span></span>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card color="basil" flat>
                        <v-card-text>{{ text }}</v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
              <!--============ FIM CARD DE EXIBIÇÃO DOS DADOS ACADÉMICOS ===========-->
            </v-col>
            <!-- ======== CONTAINER DIREITO DA TELA ============-->
          </v-row>

          <!--========== COMPONENTES EXTERNOS USADOS NA TELA=============-->
          <guiatransferencia v-if="$store.state.showDialogGuia.guia" />
          <fichadadosbiograficoacademico v-if="$store.state.showDialogGuia.ficha"/>
          <historicoacademico v-if="$store.state.showDialogGuia.historico" />
          <cartaoescolar v-if="$store.state.showDialogGuia.cartao" />
          <declaracaonotas v-if="$store.state.showDialogGuia.declaracao_nota" />
          <declaracao v-if="$store.state.showDialogGuia.declaracao" />
          <cartarecomendacao v-if="$store.state.showDialogGuia.carta" />
          <!--========== FIM COMPONENTES EXTERNOS USADOS NA TELA=============-->
        </v-card>
      </v-container>
    </template>

    <!--================ CARD TRANCAR MATRÍCULA ===============-->
    <v-dialog v-model="dialogTrancarMatricula" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: #006699">
          <span style="color: white" class="text-h5">Trancar a matrícula</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="12">
                <v-card>
                  <v-card-title>
                    <span style="font-size: 16px">Última inscrição na turma</span>
                  </v-card-title>
                  <hr />
                  <v-card-text>
                    <v-row>
                      <v-col md="12">
                        <span> Curso: </span>
                        <span style="font-weight: bold">{{ estudante_dados.length ? estudante_dados[0].curso : ""}}</span>
                      </v-col>
                      <v-col md="12">
                        <span> Turma: </span>
                        <span style="font-weight: bold">{{estudante_dados.length ? estudante_dados[0].turma : ""}}</span>
                      </v-col>
                      <v-col md="12">
                        <span> Classe: </span>
                        <span style="font-weight: bold">{{estudante_dados.length ? estudante_dados[0].classe : ""}}</span>
                      </v-col>
                      <v-col md="12">
                        <span> Situação: </span>
                        <span style="font-weight: bold">ACTIVO</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer> <v-btn color="red darken-1" text @click="dialogTrancarMatricula = false"> Cancelar </v-btn>
          <v-btn color="green darken-1" text :disabled="!estudante_dados.length" @click="confirmarMatricula()"> Trancar matrícula</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfrmar" persistent max-width="490">
      <v-card>
        <v-card-title class="text-h5"> Trancar Matrícula </v-card-title>
        <v-card-text >Ao clicar em continuar , o estudante terá a sua matrícula trancada.<br />Deseja <b>continuar</b> com a operação ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogConfrmar = false"> Cancelar </v-btn>
          <v-btn color="green darken-1" text @click="saveTrancarMatricula()"> Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--================ FIM CARD TRANCAR MATRÍCULA ===============-->
    
    <!--============ CARD EDITAR FOTO DO ESTUDANTE ============-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoUpload" persistent max-width="450px">
          <v-card>
            <v-card-title style="background-color: #006699">
              <span class="text-h5" style="color: white">Carregar foto </span
              ><br />
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="2" md="2"></v-col>
                  <v-col cols="12" sm="10" md="10">
                    <v-col md="8">
                      <div>
                        <div class="content">
                          <section class="cropper-area">
                            <div class="img-cropper">
                              <vue-cropper v-if="imgSrc !== ''" ref="cropper" :aspect-ratio="20 / 20" :src="imgSrc" preview=".preview"/>
                            </div>
                          </section>
                          <v-btn v-if="imgSrc !== ''" small @click.prevent="cropImage" fab dark color="#808080"><v-icon small dark>crop</v-icon></v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-col>
                </v-row>
                <hr />
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="resetLoadImage()">Cancelar</v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--============ FIM CARD EDITAR FOTO DO ESTUDANTE ============-->
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  components: {
    VueCropper,
    guiatransferencia: () => import("../tec-ped/componentes/guiatransferencia.vue"),
    fichadadosbiograficoacademico: () => import("../tec-ped/componentes/fichadadosbiografico.vue"),
    historicoacademico: () => import("../tec-ped/componentes/historicoacademico.vue"),
    cartaoescolar: () => import("../tec-ped/componentes/cartao.vue"),
    declaracaonotas: () => import("../tec-ped/componentes/declaracao_nota.vue"),
    declaracao: () => import("../tec-ped/componentes/declaracao.vue"),
    cartarecomendacao: () => import("../tec-ped/componentes/carta.vue"),
    loading: () => import("../../components/loading.vue")
  },
  data: () => ({
    menubi: false,
    menu: false,
    datebi: null,
    date: null,
    isLoading_: false,
    formEditarDados: false,
    search: null,
    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    idMatricula: null,
    matricula_actual: "",
    msg_pesquisa: true,
    pesquisa: "",
    estudante: true,
    dialogTrancarMatricula: false,
    dialog: false,
    dialogConfrmar: false,
    dialogoUpload: false,
    data: null,
    imgSrc: "",
    cropImg: "",
    progresso: false,
    progresso2: false,
    Pessoas: [],
    tab: null,
    items: ["Dados académicos", "Outras informações"],
    text: "Informação indisponível de momento.",
    titulo: "",
    progress: false,
    componente: [],
    items1: ["Aluno", "Funcionário"],
    items2: ["Nome", "Bilhete de Identidade", "Número de Matricula"],
    ano: ["2017", "2018", "2019", "2020"],
    headers: [
      { text: "Curso - Inscrito ", value: "descricao_curso" },
      { text: "Classes( Feitas )", value: "classe" },
      { text: "Turma", value: "descricao_turma" },
      { text: "Ano Lectivo", value: "anoLectivo" },
      { text: "Aprov.", value: "resultado" },
      { text: "Estado", value: "estado" },
    ],
    headersf: [
      { text: "Ano de Admissão ", value: "descricao_curso" },
      { text: "Função", value: "idAno_Academico" },
    ],
    overlay: false,
    foto: "",
    instituicao_id: ls.get("i_id"),
    cor: "",
    msg: "",
    objEstudante: null,
    editedIndex: -1,
    alunos: ls.get("estudantes"),
    editedItem: {
      anoLectivo: "",
      bi: "",
      curso: "",
      data_: "",
      foto: "",
      idMatricula: "",
      instituicao: "",
      nome: "",
      pkPessoa: 0,
      resultado: "",
      turma: "",
    },
    defaultItem: {
      anoLectivo: "",
      bi: "",
      curso: "",
      data_: "",
      foto: "",
      idMatricula: "",
      instituicao: "",
      nome: "",
      pkPessoa: 0,
      resultado: "",
      turma: "",
    },
    estudanteSelected: {
      nomeDoEstudante: '',
      bilheteDoEstudante: '',
      dataBiEstudante: '',
      dataNascEstudante: '',
      nomeDoPai: '',
      nomeDaMae: '',
      telefoneEstudante: '',
      matriculaEstudante: ''
    },
    estudanteSelectedDefault: {
      nomeDoEstudante: '',
      bilheteDoEstudante: '',
      dataBiEstudante: '',
      dataNascEstudante: '',
      nomeDoPai: '',
      nomeDaMae: '',
      telefoneEstudante: '',
      matriculaEstudante: ''
    },
    provinciasAll: [],
    provinciaSelected: null,
    municipioSelected: null,
    municipiosFiltered: [],
    municipiosAll: [],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    sexoSelected: null,
    dropdowSexo: [
        { idSexo: 'M', descricao: 'Masculino' },
        { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    periodoSelected: null
  }),

  computed: {
    licencaExpirada() {
      return ls.get("licencaExpirada");
    },
    isFinalista() {
      return this.estudante_dados.filter((e) => parseInt(e.idAno_Academico) === 4 && e.resultado === "Transita").length;
    },
    idclasse() {
      return this.$store.state.idclasse;
    },
    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },
    role() {
      return ls.get("role");
    },
    anolectivo() {
      return ls.get("anolectivo");
    },
  },
  watch: {
    estudantes() {
      this.$store.state.isloading = false;
    },
    search(val) {
      if (val && val.length > 0) {
        if (!this.alunos.filter((t) => t.nome.includes(val)).length) {
          this.alunos = [];
        }
        return this.pesquisaEstudante(val);
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  created() {
    this.$store.state.showDialogGuia = {
      cartao: false,
      carta: false,
      declaracao: false,
      declaracao_nota: false,
      ficha: false,
      guia: false,
      historico: false,
      listaestudante: false,
    };
    console.log(this.$store.state.objaluno);
    
    if (!this.$store.state.objaluno) {
         
    } else {
      this.editedItem = this.$store.state.objaluno;
      this.getHistoricoAluno();
      this.instit = ls.get("instituicaodescricao");
      if (window.location.host.includes("localhost")) {
        this.iskilamba = true;
      } else if (window.location.host.includes("eftsk")) {
        this.iskilamba = true;
      } else if (window.location.host.includes("eftsl")) {
        this.iskilamba = false;
      }

      this.initializeProvincias();
      this.initializeMunicipiosAll()
    }

    
  },
  methods: {
    editarEstudante() {
      this.isLoading = true;
      try {
        this.estudanteSelected.nomeDoEstudante = this.estudante_dados[0].nome
        this.estudanteSelected.bilheteDoEstudante = this.estudante_dados[0].bi
        this.estudanteSelected.dataBiEstudante = this.estudante_dados[0].dataemissaobi
        this.estudanteSelected.dataNascEstudante = this.estudante_dados[0].datanascimento
        this.estudanteSelected.nomeDoPai = this.estudante_dados[0].nomedopai
        this.estudanteSelected.nomeDaMae = this.estudante_dados[0].nomedamae
        this.estudanteSelected.telefoneEstudante = this.estudante_dados[0].telefone
        this.estudanteSelected.matriculaEstudante = this.estudante_dados[0].idMAtricula
  
         // Filtrando a provincia com base no idProvincia(provincia) actual do estudante
         this.provinciaSelected = this.provinciasAll.filter((p) => p.idProvincia === this.estudante_dados[0].idProvincia)[0];
         // Filtrando o município com base no idMunicipio(municipio) actual do estudante
         this.municipioSelected = this.municipiosAll.filter((m) => m.idMunicipio === this.estudante_dados[0].idMunicipio)[0];
         // Filtrando o sexo com base no idSexo(sexo) actual do estudante
         this.sexoSelected = this.dropdowSexo.filter((s) => s.idSexo === this.estudante_dados[0].sexo)[0];
         // Filtrando o periodo com base no id(periodo) actual do estudante
         this.periodoSelected = this.periodos.filter((p) => p.id === this.estudante_dados[0].periodo || 
         p.descricao === this.estudante_dados[0].periodo)[0];
        this.formEditarDados = true;
      } catch (error) {
        Swal.fire('Error', '<p>Erro ao carregar o formulário para edição.</p>', 'error')
      } finally {
        this.isLoading = false;
      }   
    },

    fecharCardEditar() {
      this.formEditarDados = false
      this.estudanteSelected = this.estudanteSelectedDefault
      this.periodoSelected = null
      this.sexoSelected = null
      this.provinciaSelected =  null
      this.municipioSelected = null
    },

    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.estudanteSelected.dataBiEstudante = datebi
    },

    saveDate(date) {
      this.$refs.menu.save(date)
      this.estudanteSelected.dataNascEstudante= date
    },

    async initializeProvincias() {
      this.isLoading = true;
      try {
        this.provinciasAll = await axios.get('/provinciaFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Error', '<p>Erro ao carregar as províncias.</p>', 'error')
      } finally {
        this.isLoading = false;
      }
    },

    async initializeMunicipiosAll() {
      this.isLoading = true;
      try {
        this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Error', '<p>Erro ao carregar os municipios.</p>', 'error')
      } finally {
        this.isLoading = false;
      }
    },

    loadMunicipioComb(provincia) {
      // Verificando se o município atual pertence a provícia atual
      // Se sim, então não precisa "limpar" o município
      if (provincia.idProvincia !== this.municipioSelected.idProvincia) this.municipioSelected = null;
      this.municipiosFiltered = this.municipiosAll.filter((municipio) => municipio.idProvincia === provincia.idProvincia);
    },

    validarFormulario() {
      this.isLoading = true;
      try {
        const { estudanteSelected, provinciaSelected, municipioSelected } = this;
        // Verifique se os campos obrigatórios estão preenchidos
        if (
          !estudanteSelected.nomeDoEstudante ||
          !estudanteSelected.bilheteDoEstudante ||
          !estudanteSelected.dataBiEstudante ||
          !estudanteSelected.dataNascEstudante ||
          provinciaSelected === null ||
          municipioSelected === null
        ) {
          return true; // Se algum campo estiver vazio, retorne true
        } else {
          return false; // Caso contrário, retorne false
        }
        
      } catch (error) {
        Swal.fire('Error', '<p>Erro durante a validação do formulário.</p>', 'error')
      } finally {
        this.isLoading = false;
      }
    },


    async salvarDadosEstudante() {
      if (this.validarFormulario()) {
        Swal.fire('Informação', 'Os campos nome, B.I, Data de emissão do B.I, data de nascimento, Naturalidade e municípios são obrigatórios', 'warning');
      } else {
        let params = {
              nome : this.estudanteSelected.nomeDoEstudante,
              bi : this.estudanteSelected.bilheteDoEstudante,
              dataBi : this.estudanteSelected.dataBiEstudante,
              dataNascimento: this.estudanteSelected.dataNascEstudante,
              pai : this.estudanteSelected.nomeDoPai,
              mae : this.estudanteSelected.nomeDaMae,
              provincia: this.provinciaSelected.descricao,
              idProvincia: this.provinciaSelected.idProvincia,
              municipio: this.municipioSelected.descricao,
              idMunicipio: this.municipioSelected.idMunicipio,
              sexo: this.sexoSelected.idSexo,
              telefone: this.estudanteSelected.telefoneEstudante,
              matricula: this.estudanteSelected.matriculaEstudante
            }
        Swal.fire({
          title: 'Finalizar edição',
          html: ` 
          <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de finalizar a operação.</p>
          <div style="width: 90%; margin: 10 auto;">
            <div style="display: grid; grid-template-columns: 150px auto;">
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.nome}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nº do B.I</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.bi}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data de emissão do B.I:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.dataBi}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data de nascimento:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.dataNascimento}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Filho de:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.pai}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>E de:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.mae}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Natural de:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.provincia}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Municipio:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.municipio}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Sexo:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.sexo}</div>
              <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Contato:</strong></div>
              <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.telefone}</div>
            </div>
          </div>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'green',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Finalizar',
          reverseButtons: true,
        }).then(async (result) => {
          this.isLoading = true;
          if (result.isConfirmed) {
            try {
              let result = await axios.post('/editarDadosEstudante', params).then(res => res.data);
              if (result.affectedRows >= 1) {
                Swal.fire('Sucesso', '<p>Dados alterados com sucesso!</p>', 'success')
                this.fecharCardEditar();
                this.getHistoricoAluno();
              } else if (result.messages == 'Duplicate') {
                Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
              } else {
                Swal.fire('Error', '<p>Erro ao actualizar os dados do estudante.</p>', 'error')
              }            
            } catch (error) {
              Swal.fire('Error', '<p>Erro ao actualizar os dados do estudante.</p>', 'error')
            } finally {
              this.isLoading = false;
            }
          }
        })
      }
    },

    loadStudents() {
      this.pesquisaEstudante("a");
    },

    async showTrancarMatricula() {

      
      if(this.estudante_dados[0].idAno_Academico === 4 && this.estudante_dados[0].resultado === 'Transita')//Não pode permitir trancar a matrícula de estudante da 13ª classe
      {

          Swal.fire('Informação','Não é possível trancar a matrícula deste estudante','warning')

      }else{

          if (this.estudante_dados[0].status_2 == 2) {
            Swal.fire("Informação", "Estudante já com matrícula trancada", "info");
          } else this.dialogTrancarMatricula = true;

      }
        
    },

    async showHabilitarCertificado(){

        Swal.fire({
          title: "Habilitar Preparação Certificado",
          text: "Deseja habilitar a preparação novamente do certificado para este estudante ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText:'Cancelar',
          confirmButtonText: "Habilitar",
          reverseButtons:true
        }).then(async (result) => {
          if (result.isConfirmed) {

              try {
                let result  = await this.habilitarCertificado().then()
                if(result.affectedRows > 0){
                 Swal.fire('Informação','Preparação de certificado habilitada com sucesso','success')
                 this.$router.push('/estudante/pesquisa-geral')
              }
              } catch (error) {
                Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
              }
              
              
              
          }
        });

    },


    async habilitarCertificado(){

      return   await axios.post("/habilitarImpressaoCertificado", this.editedItem).then((res) => res.data);

    },

    async confirmarMatricula() {
      this.dialogConfrmar = true;
    },

    async saveTrancarMatricula() {
      this.isLoading = true;
      try {
        let params = {
          item: this.estudante_dados[0],
          autor: ls.get('nomeUsuario')
        };
        let result = await axios.post("/trancarMatricula", params).then((res) => res.data);
        if (result.affectedRows >= 1) {
          Swal.fire("Informação", "Matrícula Trancada com sucesso", "success");
          this.getHistoricoAluno();
          this.dialogTrancarMatricula = false;
          this.dialogConfrmar = false;
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar efectuar a operação",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async pesquisaEstudante(searchInDb) {
      try {
        if (!searchInDb) {
          var payload = '{"find":"all"}';
        } else {
          payload = '{"find":"' + searchInDb + '"}';
        }
        this.isLoading = true;
        this.alunos = await axios.get("/estudanteFindAll-geral/" + payload).then((res) => res.data);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "",
          text: "Ocorreu um erro ao carregar estudantes",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async comporFoto(aluno) {
      let temporaria = "";
      try {
        if (aluno && aluno.foto) {
          temporaria = await axios
            .get(
              `${ls.get("urlFoto")}readphotoBySigla/${aluno.foto}/${ls.get(
                "sigla"
              )}`
            )
            .then((res) => res.data);
        } else {
          this.foto = ls.get("urlFoto") + "readphoto/user.png";
        }
      } catch (error) {
        this.foto = ls.get("urlFoto") + "readphoto/user.png";
      } finally {
        if (temporaria.length) {
          this.foto = `${ls.get("urlFoto")}readphotoBySigla/${
            aluno.foto
          }/${ls.get("sigla")}`;
        }
      }
    },
    async getHistoricoAluno() {
      
      if (
        (this.$store.state.objaluno !== null || this.editedItem !== null) &&
        this.editedItem.idMatricula
      ) {
        try {
          this.isLoading = true;
          this.estudante_dados = await axios.get("/PesquisaGlobal/" + this.editedItem.idMatricula).then((res) => res.data);
          // this.$store.state.objaluno = this.editedItem
          if (!this.estudante_dados.length) {
            this.msg_pesquisa = false;
          } else {
            this.$store.state.objaluno = this.editedItem;
            this.msg_pesquisa = true;
            this.objEstudante = this.estudante_dados[0];
            this.comporFoto(this.estudante_dados[0]);
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "",
            text: "Ocorreu um erro ao carregar o relatório",
          });
        } finally {
          this.isLoading = false;
        }
      } else {
        this.progresso = false;
      }
    },

    /**--------------------------------------------------Carregamento de Imagem------------------------------------------------------------ */
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        Swal.fire({
          icon: "warning",
          title: "",
          text: "Por favor selecione uma imagem",
        });
      } else {
        if (typeof FileReader === "function") {
          this.dialogoUpload = true;
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          Swal.fire({
            icon: "warning",
            title: "",
            text: "Ficheiro não suportado",
          });
        }
      }
    },
    cropImage() {
      try {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.savephoto();
      } catch (error) {
        this.dialogoUpload = false;
        this.imgSrc = "";
        Swal.fire({
          icon: "error",
          title: "",
          text: "Ocorreu um erro ao cortar a foto",
        });
      }
    },
    async savephoto() {
      try {
        let params = {
          fileName: this.estudante_dados[0].foto,
          ficheiro: this.cropImg,
          sigla: ls.get("sigla"),
        };
        let result = await axios({
          method: "post",
          url: `${ls.get('urlFoto')}uploadImg`, 
          data: params,
        }).then((res) => res.data);
        if (result && result.affectedRows > 0) {
          this.foto = this.cropImg;
        }
      } catch (error) {
        this.dialogoUpload = false;
        this.imgSrc = ls.get('urlFoto') + "readphoto/user.png";
        Swal.fire({
          icon: "error",
          title: "",
          text: "Ocorreu um erro ao salvar a imagem",
        });
      } finally {
        this.dialogoUpload = false;
      }
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute("data-scale", scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    resetLoadImage() {
      try {
        this.$refs.cropper.reset();
        this.cropImg = null;
      } catch (error) {
        Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
      } finally {
        this.dialogoUpload = false;
        this.imgSrc = "";
      }
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    async show_dialogo_transitacao() {
      this.dialog = true;
    },

    /** **************************************************Impressão********************************************************** */
    carregarHistoricoAcademico() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "O Histórico Académico";
        ls.set("relatorio-estudante", {
          id: 1,
          descricao: "Histórico Académico",
        });
        this.$store.state.listEstudantfromPauta = this.estudante_dados;
        this.$store.state.showDialogGuia.historico = true;
        this.$store.state.isloading = true;
      }
    },

    carregarFichaDadosBiograficoAcademico() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "A Ficha de Dados Biográfico Académico";
        ls.set("relatorio-estudante", {
          id: 3,
          descricao: "Ficha de Dados Biográfico Académico",
        });
        this.$store.state.listEstudantfromPauta = this.estudante_dados;
        this.$store.state.isloading = true;
        this.$store.state.showDialogGuia.ficha = true;
      }
    },

    carregarCartaRecomendacao() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "A Carta de recomendação";
        ls.set("relatorio-estudante", {
          id: 4,
          descricao: "Carta de recomendação",
        });
        this.$store.state.objAluno = this.estudante_dados[0];
        this.$store.state.isloading = true;
        this.$store.state.showDialogGuia.carta = true;
      }
    },

    carregarGuiaTransferencia() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "A Guia de Transferência";
        ls.set("relatorio-estudante", {
          id: 5,
          descricao: "Guia de Transferência",
        });
        let i = 0;
        this.estudante_dados.forEach((element) => {
          if (i < element.idAno_Academico) {
            i = element.idAno_Academico;
            this.$store.state.objAluno = element;
          }
        });
        this.$store.state.isloading = true;
        this.$store.state.showDialogGuia.guia = true;
      }
    },

    carregarcartaoestudante() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "O Cartão de Estudante";
        ls.set("relatorio-estudante", {
          id: 6,
          descricao: "Cartão de Estudante",
        });
        this.$store.state.objAluno = this.estudante_dados[0];
        this.$store.state.isloading = true;
        this.$store.state.showDialogGuia.cartao = true;
      }
    },
    declaracao_notas() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "A Declaração com Notas";
        ls.set("relatorio-estudante", {
          id: 7,
          descricao: "Declaração com Notas",
        });
        this.$store.state.objAluno = this.estudante_dados[0];
        this.$store.state.showDialogGuia.declaracao_nota = true;
      }
    },
    declaracao() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.titulo = "A Declaração sem Notas";
        ls.set("relatorio-estudante", {
          id: 8,
          descricao: "Declaração sem Notas",
        });
        this.$store.state.objAluno = this.estudante_dados[0];
        this.$store.state.isloading = true;
        this.$store.state.showDialogGuia.declaracao = true;
      }
    },
    carregarBoletim() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.$store.state.objAluno = this.estudante_dados[0];
        this.$store.state.backTo = "/estudante/historico-academico";
        this.$router.push("/Novo-Boletim24");
      }
    },
    carregarCertificado() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        let item = this.estudante_dados[0];
        if (item.certificado == 1) {
          window
            .open(
              "http://certificado.softlineangola.com/#/login/?q=" +
                item.idMAtricula +
                "/" +
                ls.get("token"),
              "_blank"
            )
            .focus();
        } else {
          this.$store.state.objaluno = item;
          this.$router.push("preparar-certificado-notas-PesquisaGeral");
        }
      }
    },
  },
};
</script>
 <style>
.list_items_ul {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
}
.list_items_ul .span_type {
    margin-right: 5px;
}
.font-bold {
  font-weight: bold;
}
</style>